import MyService from '../../service';

const DepositApi = {
  // Lấy danh sách phân trang
  getPagination: async (page = 1, limit = 10, part_id = null) => {
    try {
      const body = { page, limit };
      if (part_id) body.part_id = part_id;
      const result = await MyService.postRequestData(
        '/car-deposit/pagination-deposit',
        body
      );
      return result.data || [];
    } catch (error) {
      console.error('DepositApi.getPagination error:', error);
      return [];
    }
  },

  // Tạo mới
  createDeposit: async (data) => {
    try {
      const result = await MyService.postRequestData('/car-deposit', data);
      return result;
    } catch (error) {
      console.error('DepositApi.createDeposit error:', error);
      return null;
    }
  },

  // Cập nhật trạng thái hoàn tiền
  updateRefundStatus: async (depositId, payload) => {
    try {
      const result = await MyService.putRequestData(
        `/car-deposit/update-deposit-refund-status/${depositId}`,
        payload
      );
      console.log('DepositApi.updateRefundStatus result:', result);
      return result;
    } catch (error) {
      console.error('DepositApi.updateRefundStatus error:', error);
      return null;
    }
  },

  // ✅ xem chi tiết
  getById: async (depositId) => {
    try {
      const result = await MyService.getRequestData(
        `/car-deposit/get-detail-by-id/${depositId}`
      );
      return result;
    } catch (error) {
      console.error('DepositApi.getById error:', error);
      return null;
    }
  },

  // Thu tiền
  captureAuthorization: async (depositId, amount) => {
    try {
      const result = await MyService.postRequestData(
        '/payments/paypal/capture-authorization',
        { depositId, amount }
      );
      console.log('DepositApi.captureAuthorization result:', result);
      return result;
    } catch (error) {
      console.error('DepositApi.captureAuthorization error:', error);
      return null;
    }
  },

  // Trả tiền (release)
  releaseAuthorization: async (depositId, note = '') => {
    try {
      const result = await MyService.postRequestData(
        '/payments/paypal/release-authorization',
        { depositId, note }
      );
      return result;
    } catch (error) {
      console.error('DepositApi.releaseAuthorization error:', error);
      return null;
    }
  },

  //  DELETE
  deleteDeposit: async (depositId) => {
    try {
      const result = await MyService.deleteRequestData(
        `/car-deposit/delete-by-id/${depositId}`
      );
      return result;
    } catch (error) {
      console.error('DepositApi.deleteDeposit error:', error);
      return null;
    }
  },
};

export default DepositApi;
